import axios from "axios";

export const config = {
    appUrl: "/",
}

export const axiosInstance = axios.create({
    baseURL: 'https://api.zithas.co.uk/api/',
    // baseURL: 'https://edemoapi.zithas.com/api',
    headers: {
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin': '*',
    },
});



export const FetchPostData = async (toggleLoading, apiName, token, formDataEntries) => {
    try {
        toggleLoading(true);
        const formData = new FormData();
        for (const [key, value] of Object.entries(formDataEntries)) {
            formData.append(key, value);
        }
        const res = await axiosInstance.post(`${apiName}`, formDataEntries, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        toggleLoading(false);
        return res
    } catch (error) {
        console.error(error);
        toggleLoading(false);
    }
}